import { lazy, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tagsinput/react-tagsinput.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter as Router, Navigate, useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { connect } from "react-redux";
import "./css/style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ProSidebarProvider } from "react-pro-sidebar";
import { Spinner } from "react-bootstrap";
import "antd/dist/reset.css";
// Eager load critical components
import Login from "./auth/Login";
import Header from "./components/Header";
import AdminSideBar from "./components/AdminSideBar";
import Sizes from "./pages/Sizes/Sizes";
import Blogs from "./pages/Blogs/Blogs";
import BlogDetail from "./pages/Blogs/BlogDetail";
import StoreMangment from "./pages/Store";
import WalletManagement from "./pages/WalletManagement";
import ViewSizes from "./pages/Sizes/ViewSizes";

// Lazy load all other components
const items = [
  {
    label: (
      <a
        href="https://www.antgroup.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        1st menu item
      </a>
    ),
    key: "0",
  },
  {
    label: (
      <a
        href="https://www.aliyun.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        2nd menu item
      </a>
    ),
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: "3rd menu item",
    key: "3",
  },
];
const UserManagement = lazy(() => import("./pages/UserManagement/index"));
const AddEditUserManagement = lazy(() =>
  import("./pages/UserManagement/AddEditUserManagement")
);

import SellerManagement from "./components/User/Seller";
import BuyerManagement from "./components/User/Buyer";
import SellerDetails from "./components/User/SellerDetails";
import RestoreSizes from "./pages/Sizes/RestoreSizes";
import SellerAuctions from "./pages/LiveAuctions/SellerAuctions";
import BuyerBids from "./pages/LiveAuctions/BuyerBids";
import LiveAuctionDetail from "./pages/LiveAuctions/LiveAuctionDetail";
import BidsAndAsks from "./components/User/ViewBiddersAsks";
import ClothingAnalytics from "./pages/Analytics/ClothingAnalytics";
import BoxBreakAnalytics from "./pages/Analytics/BoxBreakAnalytics";
import CardGrading from "./pages/Grading/CardGrading";
const AddEditGrading = lazy(() => import("./pages/Grading/AddEditGrading"));

const Coupon = lazy(() => import("./pages/coupon/Coupon"));
const Offers = lazy(() => import("./pages/Offers/Offers"));
const AdminProfile = lazy(() => import("./pages/AdminProfile"));
const ItemListing = lazy(() => import("./pages/ItemListing"));
const RunningAuctions = lazy(() => import("./pages/RunningAuctions"));
const PastAuction = lazy(() => import("./pages/PastAuction"));
const EditListItem = lazy(() => import("./components/EditListItem"));
const HomeSliders = lazy(() =>
  import("./components/HomePageSliders/HomeSliders")
);
const SellerBulkAsk = lazy(() =>
  import("./pages/SellerBulkAsk/SellerBulkAsk"));

const PopupContent = lazy(() =>
  import("./components/PopupContent/PopupContent")
);

const BoxCategories = lazy(() => import("./pages/BrokenCards/BoxCategories"));
const BrokenCards = lazy(() => import("./pages/BrokenCards/BrokenCards"));
const BoxWalletRequests = lazy(() =>
  import("./pages/BrokenCards/BoxWalletRequests")
);
const BoxWalletRequestsDetail = lazy(() =>
  import("./pages/BrokenCards/BoxWalletRequestDetail")
);

const Wallet = lazy(() => import("./pages/BrokenCards/Wallet"));
const GradingVaultDetail = lazy(() =>
  import("./pages/BrokenCards/GradingVaultDetail")
);
const ViewCardDetail = lazy(() => import("./pages/BrokenCards/ViewCardDetail"));
const AddCard = lazy(() => import("./pages/BrokenCards/AddCards"));
const Category = lazy(() => import("./pages/Category"));
const BidManagement = lazy(() => import("./pages/BidManagement"));
const CMS = lazy(() => import("./pages/CMSPages/CMS"));
const FAQ = lazy(() => import("./pages/CMSPages/FAQ"));
const Policy = lazy(() => import("./pages/CMSPages/Policy"));
const Terms = lazy(() => import("./pages/CMSPages/Terms"));
const HowItWorks = lazy(() => import("./pages/CMSPages/HowItWorks"));
const HomePages = lazy(() => import("./pages/CMSPages/HomePages"));
const PointsSystem = lazy(() => import("./pages/LevelSystem/PointsSystem"));
const WhatIsInsertBid = lazy(() => import("./pages/CMSPages/WhatIsInsertBid"));
const ContactUs = lazy(() => import("./pages/CMSPages/ContactUs"));
const SellItem = lazy(() => import("./pages/CMSPages/SellItem"));
const SalesHistory = lazy(() => import("./pages/SalesHistory"));
const Staff = lazy(() => import("./pages/StaffManage"));
const AddEditStaff = lazy(() => import("./pages/StaffManage/addEditStaff"));
const DisputesList = lazy(() => import("./pages/Disputes"));
const AboutUsContent = lazy(() => import("./pages/CMSPages/AboutUsContent"));
const FlagCommentsList = lazy(() => import("./pages/FlagCommentsList"));
const ChangePassword = lazy(() =>
  import("./components/ChangePassword/ChangePassword")
);
const PhotoGuide = lazy(() => import("./pages/CMSPages/PhotoGuide"));
const HeaderContent = lazy(() => import("./pages/CMSPages/HeaderContent"));
const NotifyUsers = lazy(() => import("./pages/NotifyUsers"));
const StoreManager = lazy(() => import("./pages/StoreManager"));
const AwardsSystem = lazy(() => import("./pages/AwardsSysten"));
const ApproveAuction = lazy(() => import("./pages/ApproveAuction"));
const NewsLetter = lazy(() => import("./pages/NewsLetter"));
const BoxBreakOrders = lazy(() => import("./pages/BrokenCards/BoxBreakOrders"));
const BoxBreakOrderDetail = lazy(() =>
  import("./pages/BrokenCards/BoxBreakOrderDetail")
);
const Subscribers = lazy(() => import("./pages/Subscribers/Subscribers"));
const Contacts = lazy(() => import("./pages/Contacts"));
const CookiePolicy = lazy(() => import("./pages/CMSPages/CookiePolicy"));
const DPA = lazy(() => import("./pages/CMSPages/DPA"));
const Orders = lazy(() => import("./pages/Orders"));
const ViewOrders = lazy(() => import("./pages/ViewOrders"));
const Payments = lazy(() => import("./pages/Payments"));
const Analytics = lazy(() => import("./pages/Analytics"));
const ReturnPolicy = lazy(() => import("./pages/CMSPages/ReturnPolicy"));
const AuditLogs = lazy(() => import("./pages/AuditLogs"));
const AuditLogsList = lazy(() => import("./pages/AdminAuditLogs/AuditLogsList"));
const Products = lazy(() => import("./pages/Products/Products"));
const AddProducts = lazy(() => import("./pages/Products/AddProducts"));
const Attributes = lazy(() => import("./pages/Attributes/Attributes"));
const AddVariants = lazy(() => import("./pages/Products/AddVariants"));
const AddSize = lazy(() => import("./pages/Products/AddSize"));
const Brands = lazy(() => import("./pages/Brands/Brands"));
const Activity = lazy(() => import("./pages/Activity/Activity"));
const CreateVariants = lazy(() => import("./pages/Products/CreateVariants"));
const VariantsList = lazy(() => import("./pages/Products/VariantsList"));
const AuctionDetails = lazy(() => import("./pages/AuctionDetails"));
const Variants = lazy(() => import("./pages/Variants/Variansts"));
const ItemswithSubitems = lazy(() => import("./pages/Type/ItemswithSubitems"));

const Type = lazy(() => import("./pages/Type/Type"));

const LatestAddProduct = lazy(() =>
  import("./pages/Products/Latest/AddProductLatest")
);

const StoreProducts = lazy(() =>
  import("./pages/Products/Latest/StoreProducts")
);
const Model = lazy(() => import("./pages/Model/Model"));
const Materials = lazy(() => import("./pages/Materials/Materials"));
const Seasons = lazy(() => import("./pages/Seasons/Seasons"));
const Gender = lazy(() => import("./pages/Gender/Gender"));
const Country = lazy(() => import("./pages/Country/Country"));
const Subtype = lazy(() => import("./pages/Subtype/Subtype"));

const SuggestionRequest = lazy(() =>
  import("./pages/SuggestionRequest/SuggestionRequest")
);
const Color = lazy(() => import("./pages/Color/Color"));
const Region = lazy(() => import("./pages/Region/Region"));
const SizeCategory = lazy(() => import("./pages/SizeCategory/SizeCategory"));

// Loading component
const LoadingFallback = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ minHeight: "400px" }}
  >
    <Spinner animation="border" variant="warning" />
  </div>
);

function App({ user, isLoading, resetToken }) {
  const AuthRoutes = () =>
    useRoutes([
      { path: "/", element: <Login /> },
      { path: "/login", element: <Login /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ]);

  const AfterLoginCustomerRoutes = () =>
    useRoutes([
      { path: "/", element:<ClothingAnalytics /> },
      { path: "/home-page-slider", element: <HomeSliders /> },
      { path: "/popup-content", element: <PopupContent /> },
      { path: "/add-variant/:productId/:status", element: <CreateVariants /> },
      { path: "/profile", element: <AdminProfile /> },
      { path: "/change-password", element: <ChangePassword /> },
      { path: "/users", element: <UserManagement /> },
      { path: "/seller", element: <SellerManagement /> },
      { path: "/seller-ask", element: <BidsAndAsks type={"seller"} /> },
      { path: "/seller-bulk-ask", element: <SellerBulkAsk /> },
      { path: "/buyer", element: <BuyerManagement /> },
      { path: "/buyer-bid", element: <BidsAndAsks type={"buyer"} /> },
      { path: "/seller/:id", element: <SellerDetails /> },
      { path: "/addUser", element: <AddEditUserManagement /> },
      { path: "/editUser/:id", element: <AddEditUserManagement /> },
      { path: "/item-listing", element: <ItemListing /> },
      { path: "/item-details/:id", element: <ApproveAuction /> },
      { path: "/sales-history", element: <SalesHistory /> },
      { path: "/orders", element: <Orders /> },
      { path: "/view-orders/:id", element: <ViewOrders /> },
      { path: "/seller-auctions", element: <SellerAuctions /> },
      { path: "/seller-auctions/:id", element: <LiveAuctionDetail type="auction" /> },
      { path: "/buyer-bids", element: <BuyerBids /> },
      { path: "/buyer-bids/:id", element: <LiveAuctionDetail type="bid" /> },
      { path: "/products", element: <Products /> },
      { path: "/variantslist", element: <Variants /> },
      { path: "/items-subitems/:name/:id", element: <ItemswithSubitems /> },
      { path: "/coupon", element: <Coupon /> },
      { path: "/offers", element: <Offers /> },
      {path:"/grading",element:<CardGrading/>},
      { path: "/grading/add", element: <AddEditGrading /> },
      { path: "/grading/edit/:id", element: <AddEditGrading /> },
      {
        path: "/view-details/:id",
        element: <AuctionDetails type="sellerVariants" />,
      },
      // { path: "/add-product", element: <AddProducts /> },
      // { path: "/edit-product/:id", element: <AddProducts type="edit" /> },
      { path: "/model", element: <Model /> },
      { path: "/material", element: <Materials /> },
      { path: "/seasons", element: <Seasons /> },
      { path: "/gender", element: <Gender /> },
      { path: "/size", element: <Sizes /> },
      { path: "restore-size", element: <RestoreSizes /> },
      {
        path: "/view-size/:selectedCategory/:selectedBrand/:selectedGender",
        element: <ViewSizes />,
      },
      {
        path: "/view-deleted-size/:selectedCategory/:selectedBrand/:selectedGender",
        element: <ViewSizes type="deleted" />,
      },
      { path: "/country", element: <Country /> },
      { path: "/subtypes", element: <Subtype /> },
      { path: "/requests", element: <SuggestionRequest /> },
      { path: "/color", element: <Color /> },
      { path: "/region", element: <Region /> },
      { path: "/sizecategory", element: <SizeCategory /> },
      { path: "/blogs/", element: <Blogs /> },
      { path: "/blogdetail", element: <BlogDetail /> },
      { path: "/editblogs/:id", element: <Blogs /> },
      { path: "/store", element: <StoreMangment /> },
      { path: "/wallet", element: <WalletManagement /> },
      {
        path: "/edit-product/:id/:suggestedProductId",
        element: <LatestAddProduct type={"edit"} api={"edit"} />,
      },
      {
        path: "/view-product/:id/:suggestedProductId",
        element: <LatestAddProduct type={"edit"} api={"edit"} view={true} />,
      },
      {
        path: "/store-products",
        element: <StoreProducts />,
      },
      {
        path: "/suggested-product/:id/:suggestedProductId",
        element: (
          <LatestAddProduct
            type={"edit"}
            previous={"request"}
            api={"editSuggestedProduct"}
          />
        ),
      },

      { path: "/latest-product", element: <LatestAddProduct /> },
      { path: "/attributes", element: <Attributes /> },
      { path: "/add-size", element: <AddSize /> },
      { path: "/brands", element: <Brands /> },
      { path: "/activity", element: <Activity /> },
      { path: "/type", element: <Type /> },
      { path: "/variants/:id", element: <VariantsList /> },
      { path: "/auction-details/:id", element: <AuctionDetails /> },
      { path: "/payments", element: <Payments /> },
      { path: "/logs", element: <AuditLogs /> },
      { path: "/audit-logs", element: <AuditLogsList /> },
      { path: "/bid-management", element: <BidManagement /> },
      { path: "/store-management", element: <StoreManager /> },
      { path: "/cms-pages/header", element: <HeaderContent /> },
      { path: "/cms-pages/homepages", element: <HomePages /> },
      { path: "/cms-pages/faq", element: <FAQ /> },
      { path: "/cms-pages/privacy-policy", element: <Policy /> },
      { path: "/cms-pages/terms", element: <Terms /> },
      { path: "/cms-pages/cookie-policy", element: <CookiePolicy /> },
      { path: "/cms-pages/return-policy", element: <ReturnPolicy /> },
      { path: "/cms-pages/what-is-insert-bids", element: <WhatIsInsertBid /> },
      { path: "/cms-pages/how-it-works", element: <HowItWorks /> },
      { path: "/cms-pages/contact-us", element: <ContactUs /> },
      { path: "/cms-pages/about-us", element: <AboutUsContent /> },
      { path: "/cms-pages/dpa", element: <DPA /> },
      { path: "/newsletters", element: <NewsLetter /> },
      { path: "/subscribers", element: <Subscribers /> },
      { path: "/queries", element: <Contacts /> },
      { path: "/cms-pages/sell-an-item", element: <SellItem /> },
      { path: "/cms-pages/photo-guide", element: <PhotoGuide /> },
      { path: "/edit-list/:id", element: <EditListItem /> },
      { path: "/category", element: <Category /> },
      { path: "/badge", element: <PointsSystem /> },
      { path: "/awards", element: <AwardsSystem /> },
      { path: "/staff", element: <Staff /> },
      { path: "/staff/:id", element: <AddEditStaff /> },
      { path: "/staff/add", element: <AddEditStaff /> },
      { path: "/disputes", element: <DisputesList /> },
      { path: "/flag-comments", element: <FlagCommentsList /> },
      { path: "/change-password", element: <ChangePassword /> },
      { path: "/broken-cards", element: <BrokenCards /> },
      { path: "/box-requests", element: <BoxWalletRequests /> },
      { path: "/box-break-orders", element: <BoxBreakOrders /> },
      { path: "/box-break-orders/:id", element: <BoxBreakOrderDetail /> },
      {
        path: "/box-requests-detail/:id",
        element: <BoxWalletRequestsDetail />,
      },
      {
        path: "/box-break-vault",
        element: <Wallet />,
      },
      {
        path: "/box-break-vault-detail/:id",
        element: <GradingVaultDetail />,
      },
      {
        path: "/broken-card-category",
        element: <BoxCategories />,
      },
      {
        path: "/clothing-analytics",
        element: <ClothingAnalytics />,
      },
      {
        path: "/box-break-analytics",
        element: <BoxBreakAnalytics />,
      } ,
      { path: "/view-card/:id", element: <ViewCardDetail /> },
      { path: "/add-cards", element: <AddCard /> },
      { path: "/edit-cards/:id", element: <AddCard type="edit" /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ]);

  const StoreManagerRoutes = () =>
    useRoutes([
      { path: "/", element: <ClothingAnalytics /> },
      { path: "/categories", element: <Category /> },
      { path: "/type", element: <Type /> },
      { path: "/brands", element: <Brands /> },
      { path: "/activity", element: <Activity /> },
      { path: "/model", element: <Model /> },
      { path: "/materials", element: <Materials /> },
      { path: "/subtypes", element: <Subtype /> },
      { path: "/seller-auctions", element: <SellerAuctions /> },
      { path: "/seller-auctions/:id", element: <LiveAuctionDetail type="auction" /> },
      { path: "/buyer-bids", element: <BuyerBids /> },
      { path: "/buyer-bids/:id", element: <LiveAuctionDetail type="bid" /> },
      { path: "/products", element: <Products /> },
      { path: "/seasons", element: <Seasons /> },
      { path: "/gender", element: <Gender /> },
      { path: "/color", element: <Color /> },
      { path: "/size", element: <Sizes /> },
      { path: "restore-size", element: <RestoreSizes /> },
      {
        path: "/view-size/:selectedCategory/:selectedBrand/:selectedGender",
        element: <ViewSizes />,
      },
      {
        path: "/view-deleted-size/:selectedCategory/:selectedBrand/:selectedGender",
        element: <ViewSizes type="deleted" />,
      },
      { path: "/region", element: <Region /> },
      { path: "/sizecategory", element: <SizeCategory /> },
      { path: "/items-subitems/:name/:id", element: <ItemswithSubitems /> },
      {
        path: "/edit-product/:id/:suggestedProductId",
        element: <LatestAddProduct type={"edit"} api={"edit"} />,
      },
      {
        path: "/view-product/:id/:suggestedProductId",
        element: <LatestAddProduct type={"edit"} api={"edit"} view={true} />,
      },
      { path: "*", element: <Navigate to="/" replace /> },
      { path: "/blogs/", element: <Blogs /> },
      { path: "/blogdetail", element: <BlogDetail /> },
      { path: "/editblogs/:id", element: <Blogs /> },
      { path: "/auction-details/:id", element: <AuctionDetails /> },
      { path: "/item-listing", element: <ItemListing /> },
      { path: "/orders", element: <Orders /> },
      { path: "/view-orders", element: <ViewOrders /> },
    ]);

  const SideBarDashBoard = () => {
    return (
      <ProSidebarProvider>
        <AdminSideBar />
      </ProSidebarProvider>
    );
  };
  return (
    <Router>
      <ToastContainer limit={1} autoClose={2000} />
      {user ? (
        <>
          <Header />
          <div className="d-flex">
            <SideBarDashBoard />
            <div className="home-page w-100">
              {isLoading && (
                <Spinner
                  animation="border"
                  variant="warning"
                  className="spinner"
                />
              )}
              <Suspense fallback={<LoadingFallback />}>
                <AfterLoginCustomerRoutes />
                {/* {user?.role === "admin" ? <AfterLoginCustomerRoutes /> : <StoreManagerRoutes />} */}
              </Suspense>
            </div>
          </div>
        </>
      ) : (
        <AuthRoutes />
      )}
    </Router>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state?.auth?.user,
    resetToken: state?.auth?.resetToken,
    isLoading: state.loading.isLoading,
  };
};

export default connect(mapStateToProps)(App);
